import { LoadingButton } from "@mui/lab";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import { Controller } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import { Link as RouterLink } from "react-router-dom";
import LogoUlo from "../../../components/LogoUlo/LogoUlo";
import { LupaPasswordFormModel } from "../hooks/useLupaPasswordForm";

interface LupaPasswordCardProps {
    lupaPasswordForm: LupaPasswordFormModel;
}

const LupaPasswordCard = ({ lupaPasswordForm }: LupaPasswordCardProps) => {
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));
    const {
        backTo,
        backToLabel,
        captchaSiteKey,
        form,
        isButtonLoading,
        onCaptchaChange,
        onCaptchaExpired,
        onSubmit,
    } = lupaPasswordForm;

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = form;

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ height: "100vh" }}
        >
            <Box
                minHeight="50vh"
                minWidth="50vw"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="fit-content"
                paddingX={isTabletScreen ? 4 : undefined}
                paddingY={4}
                border="1px solid rgba(0, 0, 0, 0.12)"
                borderRadius="6px"
                sx={{ backgroundColor: "#fff" }}
            >
                <Stack spacing={3} alignItems="center">
                    <Link
                        href="https://ukmlokal.com/"
                        rel="noreferrer"
                        target="_blank"
                    >
                        <LogoUlo width="100px" />
                    </Link>
                    <Box>
                        <Typography
                            component="div"
                            textAlign="center"
                            variant="h6"
                            fontWeight="bold"
                        >
                            Lupa{" "}
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                sx={{ color: "#20965F" }}
                                display="inline"
                            >
                                Kata Sandi?
                            </Typography>
                        </Typography>
                        <Typography
                            marginTop={1}
                            variant="body2"
                            textAlign="center"
                            width="300px"
                        >
                            Masukkan email anda untuk mendapatkan tautan atur
                            ulang kata sandi.
                        </Typography>
                    </Box>
                    <form
                        style={{
                            width: "100%",
                            maxWidth: "600px",
                            minWidth: "300px",
                        }}
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="body2">Email</Typography>
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            error={Boolean(errors.email)}
                                        >
                                            <OutlinedInput
                                                id="email"
                                                type="email"
                                                autoComplete="email"
                                                autoFocus={isLaptopScreen}
                                                placeholder="Contoh: ulo@gmail.com"
                                                size="small"
                                                {...field}
                                            />
                                            <FormHelperText>
                                                {errors.email
                                                    ? errors.email.message
                                                    : " "}
                                            </FormHelperText>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Box
                            marginTop={1}
                            display="flex"
                            justifyContent="center"
                        >
                            <ReCAPTCHA
                                key={captchaSiteKey}
                                sitekey={captchaSiteKey}
                                onChange={onCaptchaChange}
                                onExpired={onCaptchaExpired}
                                hl="id"
                                theme="light"
                            />
                        </Box>
                        <LoadingButton
                            loading={isButtonLoading}
                            loadingPosition="center"
                            type="submit"
                            fullWidth
                            size="medium"
                            variant="contained"
                            sx={{ marginTop: 3 }}
                        >
                            Kirim email
                        </LoadingButton>
                    </form>
                    <Box
                        display="flex"
                        justifyContent="center"
                        marginTop={3}
                        sx={{ width: "100%" }}
                    >
                        <Link
                            component={RouterLink}
                            to={backTo}
                            variant="body2"
                            underline="hover"
                            sx={{ cursor: "pointer" }}
                        >
                            {backToLabel}
                        </Link>
                    </Box>
                </Stack>
            </Box>
        </Box>
    );
};

export default LupaPasswordCard;
